export enum ShowStatus {
  Unknown = 0,
  NotRecognized = 1,
  Imported = 2,
  Published = 3,
  Draft = 4,
  Validated = 5,
  Unpublished = 6,
}

export enum StockStatus {
  Unknown = 0,
  SoldOut = 1,
  Available = 2,
}
